"use client";

import { useEffect, useRef } from "react";

const PJK = "'Plus Jakarta Sans', var(--font-plus-jakarta), sans-serif";

interface DesktopSearchModalProps {
  onClose: () => void;
}

/**
 * Placeholder search overlay, surfaced from the sidebar header's
 * search icon (Figma 91:9547). Single input + a muted "coming soon"
 * caption. Reuses the `.app-modal-backdrop` + `.desktop-glass-rating
 * -modal` classes for consistent desktop glass.
 */
export default function DesktopSearchModal({ onClose }: DesktopSearchModalProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    inputRef.current?.focus();
    const onKey = (ev: KeyboardEvent) => {
      if (ev.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="app-modal-backdrop"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="app-anim-scale-in desktop-glass-rating-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 480,
          maxWidth: "calc(100vw - 32px)",
          padding: 24,
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <input
          ref={inputRef}
          type="search"
          placeholder="Search across everything…"
          autoComplete="off"
          style={{
            width: "100%",
            background: "transparent",
            border: "none",
            outline: "none",
            fontFamily: PJK,
            fontWeight: 500,
            fontSize: 16,
            lineHeight: "24px",
            color: "#F2F0ED",
          }}
        />
        <p
          style={{
            fontFamily: PJK,
            fontWeight: 500,
            fontSize: 12,
            lineHeight: "16px",
            color: "rgba(242,240,237,0.45)",
            margin: 0,
          }}
        >
          Search is coming soon.
        </p>
      </div>
    </div>
  );
}
